import { Children, cloneElement, useState, useEffect } from "react";
import Link from "next/link";
import { useRouter } from "next/router";

function match(type, a, b) {
  if (type === "full") {
    return a === b;
  } else if (type === "partial") {
    return b.startsWith(a);
  }
}

export default function ActiveLink({
  children,
  matchtype = "full",
  ignore = null,
  className = "",
  ...props
}) {
  const router = useRouter();
  const [activeClass, setActiveClass] = useState(className);

  useEffect(() => {
    let finalClass = className;
    if (
      !match(matchtype, ignore, router.asPath) &&
      (match(matchtype, props.href, router.asPath) ||
        match(matchtype, props.as, router.asPath))
    ) {
      finalClass = `${className} active`.trim();
    }
    setActiveClass(finalClass);
  }, [props.href, props.as, className, router.asPath]);

  return (
    <Link {...props} className={activeClass}>
      {children}
    </Link>
  );
}
